export var CommandType;
(function (CommandType) {
    CommandType[CommandType["Speed"] = 0] = "Speed";
    CommandType[CommandType["GoForward"] = 1] = "GoForward";
    CommandType[CommandType["GoBackward"] = 2] = "GoBackward";
    CommandType[CommandType["TurnRight"] = 3] = "TurnRight";
    CommandType[CommandType["TurnLeft"] = 4] = "TurnLeft";
    CommandType[CommandType["SpotTurnRight"] = 5] = "SpotTurnRight";
    CommandType[CommandType["SpotTurnLeft"] = 6] = "SpotTurnLeft";
    CommandType[CommandType["ForceForward"] = 7] = "ForceForward";
    CommandType[CommandType["ForceBackward"] = 8] = "ForceBackward";
    CommandType[CommandType["Stop"] = 9] = "Stop";
    CommandType[CommandType["EndTurnRight"] = 10] = "EndTurnRight";
    CommandType[CommandType["EndTurnLeft"] = 11] = "EndTurnLeft";
    CommandType[CommandType["RightForward"] = 12] = "RightForward";
    CommandType[CommandType["RightBackward"] = 13] = "RightBackward";
    CommandType[CommandType["LeftForward"] = 14] = "LeftForward";
    CommandType[CommandType["LeftBackward"] = 15] = "LeftBackward";
    CommandType[CommandType["RightStop"] = 16] = "RightStop";
    CommandType[CommandType["LeftStop"] = 17] = "LeftStop";
    CommandType[CommandType["GetStatus"] = 18] = "GetStatus";
    CommandType[CommandType["SwitchRelay"] = 19] = "SwitchRelay";
})(CommandType || (CommandType = {}));
